import { useMemo } from 'react';
import { useHouseEmailAliases, type UseHouseEmailAliasesOptions } from '@/hooks/house/useHouseEmailAliases';

/**
 * Resolves a house's primary (first active) ingest email — the address users
 * forward attachments to. Shared by the settings section and the composer's
 * Email option so the derivation lives in one place.
 */
export const useHouseIngestEmail = (houseId: number, options: UseHouseEmailAliasesOptions = {}) => {
	const { data: aliases, isLoading, error } = useHouseEmailAliases(houseId, options);

	const email = useMemo(() => {
		const active = aliases?.find((alias) => alias.is_active);
		return active ? active.email_address : '';
	}, [aliases]);

	return { email, isLoading, error };
};

export default useHouseIngestEmail;
